<template>
  
  <div id="attendance">
    
    <el-tabs type="card" @tab-click="setIndex">
      <el-tab-pane label="请假申请">
        <el-leave :tabindex="tabindex"></el-leave>
      </el-tab-pane>
      <el-tab-pane label="请假记录">
        <el-records :tabindex="tabindex"></el-records>
      </el-tab-pane>
      <el-tab-pane label="出勤情况">
        <el-duty :tabindex="tabindex"></el-duty>
      </el-tab-pane>
     
    </el-tabs>
  </div>
</template>

<script>

import leave from "@/components/attendance/child/ApplicationLeave";
import records from "@/components/attendance/child/leaveRecords";
import duty from "@/components/attendance/child/onDuty";
export default {
  name: "attendance",
  components: {
    "el-leave": leave,
    "el-records": records,
    "el-duty": duty
  },
  data() {
    return {
      tabindex: "",
     
    };
  },
  created() {
    this.$global.activeMenu = "3-3"; //不激活左侧
  },
  mounted() {
   this.tabindex='0';
    
  },
  methods: {
    setIndex(e) {
      let me = this;
      me.tabindex = e.index;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#attendance{
    #leaveapply{
        padding-left:50px;padding-top:20px;
        .el-row{margin-right:-10px !important;margin-left:-10px !important;}
        .el-form-item{
          margin-bottom:20px;
        }
    }
     .el-table,
  .el-table__header thead,
  .el-button,
  .el-form-item__label,
  .el-checkbox__label,
  .el-form-item__content,
  .el-radio__label,
  .el-input__inner {
    font-size: 16px !important;
  }
  .widthauto {
    width: auto;
  }

  .el-dialog {
    margin: 0 auto;
  }

  .el-dialog__header {
    font-size: 22px;
    padding: 10px 20px;
  }

  .el-dialog__body {
    padding: 30px 20px !important;
    .hiddenTab .el-tabs__header {
      display: none;
    }
    .progress-text {
      font-size: 14px;
      margin-bottom: 15px;
    }
    
  }

  input[type="file"] {
    display: none;
  }

 
  .el-form-item__label {
    font-size: 16px;
    
  }
.el-input{
    width:auto;
}
  .el-collapse,
  .el-collapse-item__header {
    border: none;
    font-size: 18px;
    color: #3f80cc;
    strong {
      font-size: 16px;
    }
  }

  .el-tabs__active-bar {
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/attendance/attendance.vue